import { render, staticRenderFns } from "./TabItemOff.vue?vue&type=template&id=11d081b5&scoped=true&"
import script from "./TabItemOff.vue?vue&type=script&lang=js&"
export * from "./TabItemOff.vue?vue&type=script&lang=js&"
import style0 from "./TabItemOff.vue?vue&type=style&index=0&id=11d081b5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d081b5",
  null
  
)

export default component.exports